import { Alert, Box, Typography } from '@mui/material';

import Flex from '@Components/Bases/Flex';

import GreenhouseGasEmissionOrganizationForms from './GreenhouseGasEmissionOrganizationForms';

const GreenhouseGasEmissionOrganization = () => {
  return (
    <Box mt={2}>
      <Typography fontWeight={800}>
        การจัดการเพื่อลดปัญหาก๊าซเรือนกระจก:
        ปริมาณการปล่อยก๊าซเรือนกระจกขององค์กร
      </Typography>
      <Alert severity="info" sx={{ mt: 2 }}>
        <Flex>
          <Typography>คำชี้แจง :</Typography>
          <ul style={{ margin: 0 }}>
            <Typography component={'li'}>
              กรณี
              <Typography
                component={'span'}
                fontWeight={800}
                sx={{ textDecoration: 'underline' }}
              >
                ไม่มีข้อมูลหรือไม่เกี่ยวข้องกับการดำเนินธุรกิจของบริษัท
              </Typography>
              ให้เว้นช่องว่าง ไม่ต้องระบุข้อมูล
            </Typography>
            <Typography component={'li'}>
              {`กรณีตรวจสอบข้อมูลตามปีที่รายงานแล้ว พบว่ามีค่าเป็น 0 ให้ระบุ 0 (ศูนย์)`}
            </Typography>
          </ul>
        </Flex>
      </Alert>
      <GreenhouseGasEmissionOrganizationForms />
    </Box>
  );
};

export default GreenhouseGasEmissionOrganization;
